export default {
    gatewayNames: {
        stripe: 'stripe',
        bankTransfer: 'banktransfer',
        accountBalance: 'accountbalance',
        payfast: 'payfast',
    },
};
